/** Expanded breed lists for pet insurance autocomplete (substring match as user types). */

export const DOG_BREEDS: readonly string[] = [
  'Affenpinscher',
  'Afghan Hound',
  'Airedale Terrier',
  'Akita',
  'Alaskan Klee Kai',
  'Alaskan Malamute',
  'American Bulldog',
  'American English Coonhound',
  'American Eskimo Dog',
  'American Foxhound',
  'American Hairless Terrier',
  'American Leopard Hound',
  'American Pit Bull Terrier',
  'American Staffordshire Terrier',
  'American Water Spaniel',
  'Anatolian Shepherd Dog',
  'Appenzeller Sennenhund',
  'Australian Cattle Dog',
  'Australian Kelpie',
  'Australian Shepherd',
  'Australian Stumpy Tail Cattle Dog',
  'Australian Terrier',
  'Azawakh',
  'Barbet',
  'Basenji',
  'Basset Fauve de Bretagne',
  'Basset Hound',
  'Bavarian Mountain Scent Hound',
  'Beagle',
  'Bearded Collie',
  'Beauceron',
  'Bedlington Terrier',
  'Belgian Laekenois',
  'Belgian Malinois',
  'Belgian Sheepdog',
  'Belgian Tervuren',
  'Bergamasco Sheepdog',
  'Berger Picard',
  'Bernese Mountain Dog',
  'Bichon Frise',
  'Biewer Terrier',
  'Black and Tan Coonhound',
  'Black Mouth Cur',
  'Black Russian Terrier',
  'Bloodhound',
  'Bluetick Coonhound',
  'Boerboel',
  'Bolognese',
  'Border Collie',
  'Border Terrier',
  'Borzoi',
  'Boston Terrier',
  'Bouvier des Flandres',
  'Boxer',
  'Boykin Spaniel',
  'Bracco Italiano',
  'Briard',
  'Brittany',
  'Broholmer',
  'Brussels Griffon',
  'Bull Terrier',
  'Bulldog',
  'Bullmastiff',
  'Cairn Terrier',
  'Canaan Dog',
  'Cane Corso',
  'Cardigan Welsh Corgi',
  'Carolina Dog',
  'Catahoula Leopard Dog',
  'Caucasian Shepherd Dog',
  'Cavalier King Charles Spaniel',
  'Cesky Terrier',
  'Chesapeake Bay Retriever',
  'Chihuahua',
  'Chinese Crested',
  'Chinese Shar-Pei',
  'Chinook',
  'Chow Chow',
  "Cirneco dell'Etna",
  'Clumber Spaniel',
  'Cocker Spaniel',
  'Collie',
  'Coton de Tulear',
  'Croatian Sheepdog',
  'Curly-Coated Retriever',
  'Czechoslovakian Vlcak',
  'Dachshund',
  'Dalmatian',
  'Dandie Dinmont Terrier',
  'Danish-Swedish Farmdog',
  'Doberman Pinscher',
  'Dogo Argentino',
  'Dogue de Bordeaux',
  'Drentsche Patrijshond',
  'Drever',
  'Dutch Shepherd',
  'English Bulldog',
  'English Cocker Spaniel',
  'English Foxhound',
  'English Setter',
  'English Springer Spaniel',
  'English Toy Spaniel',
  'Entlebucher Mountain Dog',
  'Estrela Mountain Dog',
  'Eurasier',
  'Field Spaniel',
  'Finnish Lapphund',
  'Finnish Spitz',
  'Flat-Coated Retriever',
  'French Bulldog',
  'French Spaniel',
  'Galgo Español',
  'German Longhaired Pointer',
  'German Pinscher',
  'German Shepherd Dog',
  'German Shorthaired Pointer',
  'German Spitz',
  'German Wirehaired Pointer',
  'Giant Schnauzer',
  'Glen of Imaal Terrier',
  'Golden Retriever',
  'Gordon Setter',
  'Grand Basset Griffon Vendéen',
  'Great Dane',
  'Great Pyrenees',
  'Greater Swiss Mountain Dog',
  'Greyhound',
  'Hamiltonstövare',
  'Harrier',
  'Havanese',
  'Hokkaido',
  'Hovawart',
  'Ibizan Hound',
  'Icelandic Sheepdog',
  'Irish Red and White Setter',
  'Irish Setter',
  'Irish Terrier',
  'Irish Water Spaniel',
  'Irish Wolfhound',
  'Italian Greyhound',
  'Jack Russell Terrier',
  'Japanese Chin',
  'Japanese Spitz',
  'Jindo',
  'Kai Ken',
  'Karelian Bear Dog',
  'Keeshond',
  'Kerry Blue Terrier',
  'King Charles Spaniel',
  'Komondor',
  'Kooikerhondje',
  'Kuvasz',
  'Labrador Retriever',
  'Lagotto Romagnolo',
  'Lakeland Terrier',
  'Lancashire Heeler',
  'Lapponian Herder',
  'Leonberger',
  'Lhasa Apso',
  'Löwchen',
  'Maltese',
  'Manchester Terrier',
  'Maremma Sheepdog',
  'Mastiff',
  'Miniature American Shepherd',
  'Miniature Bull Terrier',
  'Miniature Pinscher',
  'Miniature Schnauzer',
  'Mixed breed',
  'Mountain Cur',
  'Mudi',
  'Neapolitan Mastiff',
  'Nederlandse Kooikerhondje',
  'Newfoundland',
  'Norfolk Terrier',
  'Norwegian Buhund',
  'Norwegian Elkhound',
  'Norwegian Lundehund',
  'Norwich Terrier',
  'Nova Scotia Duck Tolling Retriever',
  'Old English Sheepdog',
  'Otterhound',
  'Papillon',
  'Parson Russell Terrier',
  'Pekingese',
  'Pembroke Welsh Corgi',
  'Perro de Presa Canario',
  'Petit Basset Griffon Vendéen',
  'Pharaoh Hound',
  'Plott Hound',
  'Pointer',
  'Polish Lowland Sheepdog',
  'Pomeranian',
  'Pont-Audemer Spaniel',
  'Poodle (Miniature)',
  'Poodle (Standard)',
  'Poodle (Toy)',
  'Portuguese Podengo',
  'Portuguese Pointer',
  'Portuguese Sheepdog',
  'Portuguese Water Dog',
  'Pudelpointer',
  'Pug',
  'Puli',
  'Pumi',
  'Pyrenean Mastiff',
  'Pyrenean Shepherd',
  'Rat Terrier',
  'Redbone Coonhound',
  'Rhodesian Ridgeback',
  'Rottweiler',
  'Russell Terrier',
  'Russian Toy',
  'Saint Bernard',
  'Saluki',
  'Samoyed',
  'Schipperke',
  'Scottish Deerhound',
  'Scottish Terrier',
  'Sealyham Terrier',
  'Segugio Italiano',
  'Shetland Sheepdog',
  'Shiba Inu',
  'Shih Tzu',
  'Shikoku',
  'Siberian Husky',
  'Silken Windhound',
  'Silky Terrier',
  'Skye Terrier',
  'Sloughi',
  'Smooth Fox Terrier',
  'Soft Coated Wheaten Terrier',
  'Spanish Mastiff',
  'Spanish Water Dog',
  'Spinone Italiano',
  'Stabyhoun',
  'Staffordshire Bull Terrier',
  'Standard Schnauzer',
  'Sussex Spaniel',
  'Swedish Lapphund',
  'Swedish Vallhund',
  'Taiwan Dog',
  'Thai Ridgeback',
  'Tibetan Mastiff',
  'Tibetan Spaniel',
  'Tibetan Terrier',
  'Tosa',
  'Toy Fox Terrier',
  'Treeing Walker Coonhound',
  'Vizsla',
  'Weimaraner',
  'Welsh Springer Spaniel',
  'Welsh Terrier',
  'West Highland White Terrier',
  'Whippet',
  'Wire Fox Terrier',
  'Wirehaired Pointing Griffon',
  'Wirehaired Vizsla',
  'Xoloitzcuintli',
  'Yorkshire Terrier',
].sort((a, b) => a.localeCompare(b));

export const CAT_BREEDS: readonly string[] = [
  'Abyssinian',
  'American Bobtail',
  'American Curl',
  'American Shorthair',
  'American Wirehair',
  'Arabian Mau',
  'Asian Semi-longhair',
  'Asian Shorthair',
  'Australian Mist',
  'Balinese',
  'Bambino',
  'Bengal',
  'Birman',
  'Bombay',
  'Brazilian Shorthair',
  'British Longhair',
  'British Shorthair',
  'Burmese',
  'Burmilla',
  'California Spangled',
  'Chantilly-Tiffany',
  'Chartreux',
  'Chausie',
  'Colorpoint Longhair',
  'Colorpoint Shorthair',
  'Cornish Rex',
  'Cymric',
  'Devon Rex',
  'Domestic Longhair',
  'Domestic Medium Hair',
  'Domestic Shorthair',
  'Donskoy',
  'Dwelf',
  'Egyptian Mau',
  'European Burmese',
  'European Shorthair',
  'Exotic Longhair',
  'Exotic Shorthair',
  'German Rex',
  'Havana Brown',
  'Highlander',
  'Himalayan',
  'Japanese Bobtail',
  'Javanese',
  'Khao Manee',
  'Korat',
  'Kurilian Bobtail',
  'LaPerm',
  'Lambkin',
  'Lykoi',
  'Maine Coon',
  'Manx',
  'Mekong Bobtail',
  'Minskin',
  'Mixed breed',
  'Munchkin',
  'Nebelung',
  'Norwegian Forest Cat',
  'Ocicat',
  'Ojos Azules',
  'Oriental Longhair',
  'Oriental Shorthair',
  'Persian',
  'Peterbald',
  'Pixie-bob',
  'Ragamuffin',
  'Ragdoll',
  'Russian Blue',
  'Russian White',
  'Safari',
  'Savannah',
  'Scottish Fold',
  'Selkirk Rex',
  'Serengeti',
  'Siamese',
  'Siberian',
  'Singapura',
  'Snowshoe',
  'Sokoke',
  'Somali',
  'Sphynx',
  'Thai',
  'Tonkinese',
  'Toyger',
  'Turkish Angora',
  'Turkish Van',
  'York Chocolate',
].sort((a, b) => a.localeCompare(b));

const MAX_SUGGESTIONS = 80;

function normalize(s: string): string {
  return s.trim().toLowerCase();
}

/** Breeds whose names contain the typed query (case-insensitive); starts-with matches sort first. */
export function filterBreedsForQuery(species: 'dog' | 'cat', query: string): string[] {
  const list = species === 'dog' ? DOG_BREEDS : CAT_BREEDS;
  const q = normalize(query);
  if (!q) return [];

  const matches = list.filter((name) => name.toLowerCase().includes(q));
  matches.sort((a, b) => {
    const al = a.toLowerCase();
    const bl = b.toLowerCase();
    const aStarts = al.startsWith(q) ? 0 : 1;
    const bStarts = bl.startsWith(q) ? 0 : 1;
    if (aStarts !== bStarts) return aStarts - bStarts;
    return a.localeCompare(b);
  });
  return matches.slice(0, MAX_SUGGESTIONS);
}
